import React from 'react'
import PropTypes from 'prop-types'
import { IntlProvider } from '@dragonraider5/react-intl'

function LocaleProvider({ locale, messages, formats, children }) {
  return (
    <IntlProvider
      locale={locale}
      messages={messages}
      formats={formats}
      textComponent={React.Fragment}
    >
      {React.Children.only(children)}
    </IntlProvider>
  )
}

LocaleProvider.propTypes = {
  locale: PropTypes.string.isRequired,
  messages: PropTypes.object.isRequired,
  formats: PropTypes.object,
  children: PropTypes.element.isRequired
}

export default LocaleProvider
